import { render, staticRenderFns } from "./videoModal.vue?vue&type=template&id=f4b83638&scoped=true&"
import script from "./videoModal.vue?vue&type=script&lang=js&"
export * from "./videoModal.vue?vue&type=script&lang=js&"
import style0 from "./videoModal.vue?vue&type=style&index=0&id=f4b83638&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b83638",
  null
  
)

export default component.exports